import { render, staticRenderFns } from "./zhiBoDes.vue?vue&type=template&id=f45454bc&scoped=true"
import script from "./zhiBoDes.vue?vue&type=script&lang=js"
export * from "./zhiBoDes.vue?vue&type=script&lang=js"
import style0 from "./zhiBoDes.vue?vue&type=style&index=0&id=f45454bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45454bc",
  null
  
)

export default component.exports